angular.module('jv.addToCollection.controller', [])
    .controller('jvAddToCollectionController', [
        '$scope', '$rootScope','TemplateLoader','jvCandidatesService','jvHireBroadcastSVC',
        function($scope, $rootScope,TemplateLoader,jvCandidatesService,jvHireBroadcastSVC) {
            $scope.init = function() {
                $scope.collectionEId = '';
                $scope.collectionName = '';
                $scope.duplicate = false;
                $scope.selectExistingCollection = true;
                $scope.submitted = false;
            };

            $scope.init();

            jvHireBroadcastSVC.subscribe('hidingCandidateModals', function() {
                $scope.hideCollectionModal();
            });
            
            jvHireBroadcastSVC.subscribe('showAddToCollectionModalView', function() {
                var postData = {
                    data: $scope.modalData.appIds,
                    action: 'addToCollection'
                };

                jvCandidatesService.validateCandidateDetails(postData, function(res) {
                    if (res.status !== 200 || !res.data) {
                        $scope.flags.loading = false;
                        return;
                    }
                    if(res.data.validApplicationIds.length === 0) {
                        var actionValidation = {};
                        actionValidation.show = true;
                        actionValidation.title = i18n.COMMON_COLLECTION_ADD;
                        actionValidation.message = i18n.CANDIDATES_ADD_TO_COLLECTION_PERMISSION_MSG;
                        $rootScope.$emit('actionValidation', actionValidation);
                        return;
                    }
                    $scope.modalData.validationResult = res.data;
                    $scope.modalData.appIds = $scope.modalData.validationResult.validApplicationIds;
                    var message = {};
                       message.text = i18n.COMMON_COLLECTION_MULTIPLE_ADD;
                       $scope.modalData.validationResult.message = message;
                    $scope.modals['addToCollection'] = true;
                });
            });

            $scope.hideCollectionModal = function() {
                $scope.init();
                $rootScope.$broadcast('showAddToCollectionResult', false);
            };

            $scope.changeSubmitValue = function() {
                $scope.submitted = false;
            };

            $scope.add = function() {
                var addToCollectionForm = {};
                addToCollectionForm.appIds = $scope.modalData.appIds;
                if ($scope.selectExistingCollection && $scope.collectionEId) {
                    addToCollectionForm.collectionEId = $scope.collectionEId;
                } else if ($scope.selectExistingCollection === false && $scope.collectionName) {
                    addToCollectionForm.collectionName = $scope.collectionName;
                } else {
                    //We dont have a valid collectionName or collectionEId. Error validation kicks in.
                    return;
                }
                $scope.flags.loading = true;
                jvCandidatesService.addToCollection(addToCollectionForm, function(response) {
                    $scope.flags.loading = false;
                    if (response && response.status === 409 && response.data && response.data.duplicate === true){
                        $scope.duplicate = true;
                        return;
                    } else if (response && response.status === 200) {
                        $rootScope.$broadcast('showAddToCollectionResult', true);
                    } else {
                        $rootScope.$broadcast('showAddToCollectionResult', false);
                    }
                    $scope.init();
                    //Hide the Modal and dont broadcast the event.
                    $scope.hideModals(false);
                });
            };
        }
]);